export default "__VITE_ASSET__Q_M2TjP9__"